export default function ResourcesPage() {
  return (
    <div>
      <h1 className="text-display-lg text-navy mb-4">Resources</h1>
      <p className="text-warm-gray">This page is under construction.</p>
    </div>
  );
}
